import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { environment } from '../../../../../../environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { StaticStampService } from 'app/common/services/StaticStamp.service';

declare var $: any;

@Component({
    selector: 'static-history',
    templateUrl: './modalHistory.template.html',
})

export class ModalHistoryComponent implements OnInit {
    public model: any = {};
    public stamp_id: number;
    public FormFilter: FormGroup;
    public currentPage: number = 1;
    public page_size: number = 10;
    public totalRow: number = 0;
    public list : any = [];

    constructor(
        private fb: FormBuilder,
        private toastr: ToastrService,
        private modalService: BsModalService,
        private staticService: StaticStampService
    ) {

    }

    ngOnInit() {
        this.createFormFilter();
        this.loadData();
    }

    loadData(range_date: any = null) {
        let options: any = {};
        if (this.currentPage < 0) {
            this.currentPage = 1;
        }
        options.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
        options.limit = this.page_size;

        if(range_date) {
            options.from = moment(range_date[0]).format('YYYY-MM-DD');
            options.to =  moment(range_date[1]).format('YYYY-MM-DD');
        }
        this.staticService.historyStamp(this.stamp_id, options).subscribe((res: any) => {
            if (res.error == false) {
                console.log(res);
                this.list = res.data;
            }
        })
    }

    createFormFilter() {
        this.FormFilter = this.fb.group({
            range_date: [null],
        });
    }

    ResetFormSearch() {
        this.currentPage = 1;
        this.FormFilter.reset();
    }

    search(data: any = {}) {
        this.currentPage = 1;
        this.loadData(data.range_date);
    }

    setPage(page: number) {
        if (page < 1) {
            this.currentPage = 1;
            return;
        }
        
        if (page !== this.currentPage) {
            this.currentPage = page;
            this.loadData();
        }
    }
    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        } else {
            this.setPage(1); //toPage = 1;
        }
    }


}




// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/static_stamp/modal/modalHistory.component.ts